import { createSlice } from "@reduxjs/toolkit";

export const lineExecutiveSlice = createSlice({
  name: "lineExecutive",
  initialState: {
    loading: false,
    lineExecutiveList: [],
    listCount: 0,
    model: false,
    error_msg: null,
    rowdata: {},
    areaManagerList: [],
    areaManagerParams: {
      no_of_pages: 0,
      page_size: 10,
      page: 1,
      search: "",
    },
    lineExecutiveParams: {
      no_of_pages: 0,
      page_size: 10,
      page: 1,
      search: "",
      currentSort: "code",
      sortOrder: "-",
    },
  },
  reducers: {
    getLineExecutives: (state) => ({ ...state, loading: true }),
    lineExecutiveListSuccessful: (state, action) => {
      var noofpages = Math.ceil(
        action.payload.response.count / state.lineExecutiveParams.page_size
      );
      return {
        ...state,
        listCount: action.payload.response.count,
        lineExecutiveList: action.payload.response.results,
        loading: false,
        lineExecutiveParams: { ...state.lineExecutiveParams, no_of_pages: noofpages },
      };
    },
    lineExecutiveAdd: (state) => ({ ...state, loading: true }),
    lineExecutiveAddSuccessful: (state) => ({
      ...state,
      loading: false,
      model: false,
      rowdata: {},
    }),
    lineExecutiveEdit: (state, action) => ({
      ...state,
      model: true,
      rowdata: action.payload,
    }),
    lineExecutiveDelete: (state) => ({ ...state, loading: false }),
    InputChangeValue: (state, action) => ({
      ...state,
      rowdata: { ...state.rowdata, [action.payload.key]: action.payload.value },
    }),
    isModelVisible: (state, action) => {
      if (!action.payload) return { ...state, model: false, rowdata: {} };
      return { ...state, model: true };
    },
    SetLineExecutiveParams: (state, action) => ({
      ...state,
      lineExecutiveParams: action.payload,
    }),
    getAreaManagerDropdown: (state) => state,
    areaManagerDropdownSuccessful: (state, action) => {
      var noofpages = Math.ceil(
        action.payload.count / state.areaManagerParams.page_size
      );
      return {
        ...state,
        areaManagerList:
          state.areaManagerParams.page === 1
            ? action.payload.results
            : [...state.areaManagerList, ...action.payload.results],
        areaManagerParams: { ...state.areaManagerParams, no_of_pages: noofpages },
      };
    },
    setAreaManagerParams: (state, action) => ({
      ...state,
      areaManagerParams: action.payload,
    }),
    apiError: (state, action) => ({
      ...state,
      loading: false,
      error_msg: action.payload,
    }),
  },
});

export const {
  getLineExecutives,
  lineExecutiveListSuccessful,
  lineExecutiveAdd,
  lineExecutiveAddSuccessful,
  lineExecutiveEdit,
  lineExecutiveDelete,
  InputChangeValue,
  isModelVisible,
  SetLineExecutiveParams,
  getAreaManagerDropdown,
  areaManagerDropdownSuccessful,
  setAreaManagerParams,
  apiError,
} = lineExecutiveSlice.actions;

export default lineExecutiveSlice.reducer;
